module.exports = __webpack_public_path__ + "img/detailDataNew.44dd6af6.png";